import * as React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import Modal from '../ui/Modal'
import MobilityDeviceForm from './MobilityDeviceFormik'
import { IMobilityOptionCategoryObject, IMobilityOptionObject } from '../../types/mobility'

interface IAddMobilityDeviceModalProps {
  categories: IMobilityOptionCategoryObject[]
  create: (mobility: IMobilityOptionObject) => Promise<any>
  getMobilityOptions: () => void
}

export default class AddMobilityDeviceModal extends React.Component<
  RouteComponentProps<any> & IAddMobilityDeviceModalProps
> {
  constructor(props: any) {
    super(props)
  }
  public render() {
    return (
      <Modal>
        <div className='fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center font-black'>
          <div className='bg-white col-4 relative'>
            <MobilityDeviceForm
              onSuccess={this.onSuccess}
              onSubmit={this.onSubmit}
              categories={this.props.categories}
              title='ADD MOBILITY DEVICE'
            >
              <button className='p1 font-grey h5 bg-white border-white mr1' onClick={this.onCancel}>
                Cancel
              </button>
              <button className='pt1 pb1 pl2 pr2 border-radius h5 bg-green border-green font-white' type='submit'>
                Add
              </button>
            </MobilityDeviceForm>
          </div>
        </div>
      </Modal>
    )
  }

  private onSubmit = (values: any): Promise<any> => {
    return new Promise<any>((resolve, reject) => {
      this.props
        .create({
          id: '',
          name: values.name,
          categoryId: values.categoryId,
          isTransferableSeat: !!values.isTransferableSeat
        })
        .then(
          (result: any) => {
            // this.props.getMobilityOptions()
            resolve()
          },
          (err: any) => {
            reject(err)
          }
        )
    })
  }

  private onSuccess = () => {
    setTimeout(() => {
      this.onCancel()
    }, 1000)
  }

  private onCancel = () => {
    this.props.history.push('/global-settings/mobility-devices')
  }
}



// WEBPACK FOOTER //
// ./src/components/global-settings/AddMobilityDeviceModal.tsx